function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.733 31.431L48.769 7.463l2.86-2.854L47.028 0l-21.3 21.29 4.614 4.604L33 23.236l9.805 9.8L0 75.842 4.163 80l42.796-42.801 10 9.995-2.653 2.664 4.604 4.599 21.336-21.33-4.6-4.605-2.913 2.91z",
  fill: "#C1A048"
});

function SvgGavelinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none"
  }, props), _ref);
}

export default SvgGavelinline;